import { shippingService } from "@/services/addressServices";
import {
  AddShipping,
  EditShipping,
  ModifyShipping,
  ShippingState,
} from "@/types/address";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ Fetch Shipping Address
export const fetchShipping = createAsyncThunk(
  "shipping/fetchShipping",
  async (userID: string | null, { rejectWithValue }) => {
    try {
      return await shippingService.getShipping(userID);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue({
          status: error.response?.status, // Capture HTTP status code
          message: error.response?.data || "Error fetching shipping data",
        });
      }
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

// ✅ Add Shipping Address
export const addShipping = createAsyncThunk(
  "shipping/addShipping",
  async (data: AddShipping, { rejectWithValue }) => {
    try {
      return await shippingService.postShipping(data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data || "Error adding shipping address"
        );
      }
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

// ✅ Update Shipping Address
export const updateShipping = createAsyncThunk(
  "shipping/updateShipping",
  async (addressData: ModifyShipping, { rejectWithValue }) => {
    try {
      return await shippingService.modifyShipping(addressData);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data || "Error updating shipping address"
        );
      }
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const editShipping = createAsyncThunk(
  "shipping/editShipping",
  async (addressData: EditShipping, { rejectWithValue }) => {
    try {
      return await shippingService.patchShipping(addressData);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data || "Error updating shipping address"
        );
      }
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

// ✅ Delete Shipping Address
export const deleteShipping = createAsyncThunk(
  "shipping/deleteShipping",
  async (shippingID: number, { rejectWithValue }) => {
    try {
      return await shippingService.deleteShipping(shippingID);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data || "Error deleting shipping address"
        );
      }
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

// Initial Redux State
const initialState: ShippingState = {
  shippingData: null,
  selectedAddress: null,
  loading: false,
  error: null,
};

// ✅ Create Shipping Slice
const shippingSlice = createSlice({
  name: "shipping",
  initialState,
  reducers: {
    setSelectedAddress: (state, action: PayloadAction<number | null>) => {
      state.selectedAddress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShipping.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShipping.fulfilled, (state, action) => {
        state.loading = false;
        state.shippingData = action.payload;
      })
      .addCase(fetchShipping.rejected, (state, action) => {
        state.loading = false;
        state.shippingData = null;
      
        state.error = action.payload as string;
      })
      .addCase(addShipping.fulfilled, () => {
        // state.shippingData = action.payload;
      })
      .addCase(updateShipping.fulfilled, () => {
        // state.shippingData = action.payload;
      })
      .addCase(editShipping.fulfilled, () => {
        // state.shippingData = action.payload;
      })
      .addCase(deleteShipping.fulfilled, () => {
        // state.shippingData = null;
      });
  },
});

export const { setSelectedAddress } = shippingSlice.actions;

export default shippingSlice.reducer;
